"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var formik_1 = require("formik");
var __1 = __importDefault(require(".."));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var FormikTextArea = function (_a) {
    var name = _a.name, antd = _a.antd, restProps = __rest(_a, ["name", "antd"]);
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var submitCount = formik_1.useFormikContext().submitCount;
    return (react_1.default.createElement(antd_1.Form.Item, __assign({}, antd),
        react_1.default.createElement(__1.default, __assign({}, restProps, field, { onChange: function (_a) {
                var value = _a.currentTarget.value;
                helpers.setValue(value === null || value === void 0 ? void 0 : value.toString());
            }, error: (meta.touched && meta.error) || submitCount > 0 ? meta.error : "" }))));
};
exports.default = FormikTextArea;
